import { isEqual } from 'lodash';
import { useEffect, useCallback } from 'react';

import useFromMenuUrlParams from 'hb-react/shared/hooks/useFromMenuUrlParams';

export const useTagsAndSort = ({
  blockId,
  blockQuery,
  setBlockQuery,
  sortBy,
}) => {
  const { query: updatedQuery, shouldUpdateFromMenu } = useFromMenuUrlParams({
    excludeKeys: [],
    parseOptions: { parseArrays: false },
  });

  const selectedTags = Object.values(blockQuery?.tags ?? {});

  const selectedSort = sortBy?.find((elem) => elem.value === blockQuery?.sort);

  const handleChangeTags = useCallback(
    (tags) => {
      setBlockQuery((prevBlockQuery) => ({
        ...prevBlockQuery,
        tags: tags.reduce((acc, tag) => ({ ...acc, [tag]: tag }), {}),
      }));
    },
    [setBlockQuery],
  );

  const handleChangeSort = useCallback(
    (sortSelected) => {
      setBlockQuery((prevBlockQuery) => ({
        ...prevBlockQuery,
        sort: sortSelected.value,
      }));
    },
    [setBlockQuery],
  );

  useEffect(() => {
    if (shouldUpdateFromMenu()) {
      const newSelectedTags = Object.values(
        updatedQuery?.[blockId]?.tags ?? {},
      );
      const newSelectedSort = sortBy?.find(
        (elem) => elem.value === updatedQuery?.[blockId]?.sort,
      );

      if (!isEqual(selectedSort, newSelectedSort)) {
        handleChangeSort(newSelectedSort);
      }
      if (!isEqual(selectedTags, newSelectedTags)) {
        handleChangeTags(newSelectedTags);
      }
    }
  }, [
    blockId,
    handleChangeSort,
    handleChangeTags,
    updatedQuery,
    selectedSort,
    selectedTags,
    sortBy,
  ]);

  return { selectedSort, selectedTags, handleChangeTags, handleChangeSort };
};
